

import HeaderElement from './Element.vue';
import MapColumn from './Column/MapColumn.vue';
import { PropType } from 'vue';
import { PageIdentity } from 'modules/spravochnik/dt-front-page-generator/src/Entity/Page';

export default {
    components: {HeaderElement, MapColumn},
    props: {
        header: {
            type: Object,
        },
        pageIdentity: {
            type: Object as PropType<PageIdentity>,
            required: true,
        },
        goBack: {
            type: Function as PropType<() => void>,
        }
    },
    emits: ['applyFilter'],
    methods: {
        onApplyFilter(identity, ...args) {
            this.$emit('applyFilter', identity, ...args);
        },
    }
}
